import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// Clerk attaches itself to window.Clerk once <ClerkProvider> mounts (see main.tsx).
// Supabase's third-party auth integration trusts Clerk's native session tokens
// (no JWT template needed) — RLS policies read auth.jwt() ->> 'sub' to identify
// the user.
declare global {
  interface Window {
    Clerk?: {
      session?: {
        getToken: () => Promise<string | null>
      }
    }
  }
}

// Script-mode escape hatch: there is no `window` (hence no Clerk session) when
// lib code runs under a Node/vite-node one-off script rather than the deployed
// app. In that case only, fall back to the service-role key, which bypasses
// RLS outright — so no accessToken callback is needed. This branch is
// unreachable from the real browser app (`window` always exists there).
const isScriptContext = typeof window === 'undefined'
const serviceRoleKey = isScriptContext ? process.env.SUPABASE_SERVICE_ROLE_KEY : undefined

export const supabase = serviceRoleKey
  ? createClient(supabaseUrl, serviceRoleKey)
  : createClient(supabaseUrl, supabaseAnonKey, {
      accessToken: async () => {
        try {
          return (await window.Clerk?.session?.getToken()) ?? null
        } catch {
          return null
        }
      },
    })
